export const SearchActionTypes = {
  SET_SEARCH_FILTER: 'SET_SEARCH_FILTER'
}